import { Row } from 'components/atoms/Row'
import styled, { useTheme } from 'styled-components'
import { AssetItem } from './types'

type Item = Omit<AssetItem, 'label' | 'tooltip' | 'token'>

interface Props {
  items: Item[]
}

export const ValuesBar = ({ items }: Props) => {
  const theme = useTheme()
  const totalShare = items.reduce((total, { share }) => total + share, 0)

  if (totalShare === 0) {
    return <Bar width={100} color={theme.colors.GrayNurse} />
  }

  return (
    <Row>
      {items.map(({ color, share }) => {
        if (share === 0) return null
        return <Bar key={color} width={share} color={color} />
      })}
    </Row>
  )
}

const Bar = styled.div<{ width: number; color?: string }>`
  height: 10px;
  width: ${({ width }) => `${width}%`};
  background-color: ${({ color }) => color};
  margin-right: 1px;

  &:first-child {
    border-radius: 2px 0 0 2px;
  }

  &:last-child {
    border-radius: 0 2px 2px 0;
  }
`
